import type { RouterOutputs } from "@repo/api";
import { useEffect } from "react";
import { useShallow } from "zustand/react/shallow";

import TableCombinationDialog from "~/components/table/table-combination-dialog";
import TableDialog from "~/components/table/table-dialog";
import { TableContext } from "~/hooks/use-table";
import { api } from "~/lib/api";
import { useLoadingStore } from "~/stores/use-loading-store";

export type Table = RouterOutputs["table"]["getAll"][number];
export type TableCombination =
  RouterOutputs["table"]["getTableCombinations"][number];

interface TableProviderProps {
  children: React.ReactNode;
}

export function TableProvider({ children }: TableProviderProps) {
  const { data: tables, isFetching: isTablesLoading } =
    api.table.getAll.useQuery(undefined, {
      initialData: [],
    });

  const { data: tableCombinations } = api.table.getTableCombinations.useQuery(
    undefined,
    {
      initialData: [],
    },
  );

  const { setLoadingStage } = useLoadingStore(
    useShallow((state) => ({
      setLoadingStage: state.setCurrentLoadingStage,
    })),
  );

  useEffect(() => {
    if (isTablesLoading) {
      setLoadingStage("tables");
    } else {
      setLoadingStage(undefined);
    }
  }, [isTablesLoading, setLoadingStage, tables]);

  const context = {
    tables,
    tableCombinations,
  };

  return (
    <TableContext.Provider value={context}>
      <TableDialog />
      <TableCombinationDialog />
      {children}
    </TableContext.Provider>
  );
}
